import { createReducer, on } from "@ngrx/store";
import { addFormaPagos, addFormaPagosError, clearFormaPagos, deleteFormaPago, updateFormaPago } from "../actions/formasPago.actions";
import { initialFormaPagosState } from "../../core/interfaces/models/formasPago.interface";

 export const formaPagosReducer = createReducer(
  initialFormaPagosState,
  on(addFormaPagos, (_, { formaPagosState }) => (
    formaPagosState
  )),
  on(addFormaPagosError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateFormaPago, (state, { formaPago }) => ({
    ...state,
    formaPagos: state.formaPagos.map(u =>
      u.id === formaPago.id ? formaPago : u
    )
  })),
  on(deleteFormaPago, (state, { id }) => ({
    ...state,
    formaPagos: state.formaPagos.filter(u => u.id !== id)
  })),
  on(clearFormaPagos, () => initialFormaPagosState)
);